import { jsx as _jsx } from "react/jsx-runtime.js";
import { assertTruthy } from "@nvon/baseline";
import lottie from "lottie-web";
import { createRef, useCallback, useEffect, useState } from "react";
/**
 * Component used to wrap lottie animations.
 */
export const NWONLottieWrapper = (props) => {
    const animationContainer = createRef();
    const [animationItem, setAnimationItem] = useState();
    // Initially create the animation
    useEffect(() => {
        if (!animationContainer.current || animationItem) {
            return;
        }
        const anim = lottie.loadAnimation({
            container: animationContainer.current,
            renderer: "svg",
            loop: false,
            autoplay: false,
            animationData: props.lottieFileJson,
        });
        setAnimationItem(anim);
    }, [props.lottieFileJson, animationContainer, animationItem]);
    const playAnimation = useCallback(() => {
        // The animation item doesn't exist
        if (!animationItem) {
            return;
        }
        // Stop the animation at the last frame
        if (animationItem.currentFrame === animationItem.totalFrames - 1) {
            animationItem.stop();
        }
        animationItem.play();
    }, [animationItem]);
    useEffect(() => {
        if (!props.triggerReset) {
            return;
        }
        assertTruthy(animationItem, "animationItem not found.");
        animationItem.stop();
    }, [animationItem, props.triggerReset]);
    useEffect(() => {
        if (props.triggerPlaying) {
            playAnimation();
        }
    }, [playAnimation, props.triggerPlaying]);
    return _jsx("div", { ref: animationContainer }, void 0);
};
//# sourceMappingURL=NWONLottieWrapper.js.map